import React from 'react';
import { supportNetwork } from '../helper/network';
import { useAppKitNetwork } from '@reown/appkit/react';

export default function NetworkMenu() {
    const { chainId } = useAppKitNetwork();
    const switchNetwork = (networkid) => {
        try {
            // @ts-ignore
            window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: `0x${networkid.toString(16)}` }]
            });
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <React.Fragment>
            <div className="network on-mobile mr-3" style={{ "pointerEvents": "auto" }} onClick={() => {
                switchNetwork(supportNetwork['default'].chainId);
            }}>

                <img width={18} src={`${(chainId && supportNetwork[chainId]) ? supportNetwork[chainId].image : supportNetwork['default'].image}`} alt="Switch Network" className="mx-2" />
                <span className="ml-2 hide-on-mobile">BSC MAINNET</span>

            </div>



        </React.Fragment>
    )
}
